import { CertificateSettingsInput, ResourceReviewTypeEnum } from '@/types/schema';

const adaptCertificateSettingsOnSubmit = (
  certificateSettings: CertificateSettingsInput,
  reviewType: ResourceReviewTypeEnum,
) => {
  if (reviewType === ResourceReviewTypeEnum.NoReview) {
    const { minPercentage, ...adaptedCertificateSettings } = certificateSettings;

    return adaptedCertificateSettings;
  }

  return certificateSettings;
};

export default adaptCertificateSettingsOnSubmit;
